import { RootState } from '@src/middleware/reducers/rootReducer';

export const getPsmsState = (state: RootState) => state.psmsReducer?.psmsState;
export const getPsmsClaimsData = (state: RootState) => state.psmsReducer?.data;
export const getPsmsClaimsLoading = (state: RootState) => state.psmsReducer?.loading;
export const getPsmsClaimsError = (state: RootState) => state.psmsReducer?.error;
export const getPsmsExtendedTinDetails = (state: RootState) => state.psmsReducer?.extendedTinDetail;
export const getPSMSFilters = (state: RootState) => state.psmsReducer?.currentFilters || {};

/* For Claims Child PAGE */
export const getPsmsAppealTrendData = (state: RootState) =>
  state.psmsClaimsReducer?.appealTrendData;
export const getPsmsAppealTrendDataLoading = (state: RootState) =>
  state.psmsClaimsReducer?.appealTrendDataLoading;
export const getPsmsAppealTrendDataError = (state: RootState) =>
  state.psmsClaimsReducer?.appealTrendDataError;
export const getPsmsTopReasonsData = (state: RootState) => state.psmsClaimsReducer?.topReasonsData;
export const getPsmsTopReasonsDataLoading = (state: RootState) =>
  state.psmsClaimsReducer?.topReasonsDataLoading;
export const getPsmsTopReasonsHeaderData = (state: RootState) =>
  state.psmsClaimsReducer?.topReasonsHeaderData;
export const getPsmsTopReasonsHeaderDataLoading = (state: RootState) =>
  state.psmsClaimsReducer?.topReasonsHeaderDataLoading;
export const getPsmsClaimsTrendData = (state: RootState) =>
  state.psmsClaimsReducer?.claimsTrendData;
export const getPsmsClaimsTrendDataLoading = (state: RootState) =>
  state.psmsClaimsReducer?.claimsTrendDataLoading;

// Outcome Volume selectors
export const getPsmsOutcomeReasons = (state: RootState) => state.psmsClaimsReducer?.outcomeReasons;
export const getPsmsSubmissionReasons = (state: RootState) =>
  state.psmsClaimsReducer?.submissionReasons;
export const getPsmsReconsiderationDetails = (state: RootState) =>
  state.psmsClaimsReducer?.reconsiderationDetails;
export const getPsmsOutcomeVolumeLoading = (state: RootState) =>
  state.psmsClaimsReducer?.outcomeVolumeLoading;
/* --------------------------- */

// MCR Inventory Selectors
export const getMcrInventoryData = (state: RootState) => state.psmsClaimsReducer?.mcrInventoryData;
export const getMcrInventoryLoading = (state: RootState) =>
  state.psmsClaimsReducer?.mcrInventoryLoading;
export const getMcrInventoryError = (state: RootState) =>
  state.psmsClaimsReducer?.mcrInventoryError;
export const getMcrEvaluationDetailsData = (state: RootState) =>
  state.psmsClaimsReducer?.evaluationDetailsData;
export const getMcrEvaluationDetailsLoading = (state: RootState) =>
  state.psmsClaimsReducer?.evaluationDetailsLoading;

// Claims Summary Selectors
export const getClaimsSummaryData = (state: RootState) =>
  state.psmsClaimsReducer?.claimsSummaryData;
export const getClaimsSummaryLoading = (state: RootState) =>
  state.psmsClaimsReducer?.claimsSummaryLoading;
export const getClaimsSummaryError = (state: RootState) =>
  state.psmsClaimsReducer?.claimsSummaryError;

// Claims Appeal Submission Method Selectors
export const getPsmsClaimsAppealsSubmissionData = (state: RootState) =>
  state.psmsClaimsReducer?.claimsAppealsSubmissionData;
export const getPsmsClaimsAppealsSubmissionLoading = (state: RootState) =>
  state.psmsClaimsReducer?.claimsAppealsSubmissionLoading;
export const getPsmsClaimsAppealsSubmissionError = (state: RootState) =>
  state.psmsClaimsReducer?.claimsAppealsSubmissionError;

/* View Tax ID Details */
export const getPsmsHealthSystemData = (state: RootState) =>
  state.psmsViewTaxIdReducer?.healthSystemData;
export const getPsmsHealthSystemDataLoading = (state: RootState) =>
  state.psmsViewTaxIdReducer?.healthSystemDataLoading;
export const getPsmsExtendedTinList = (state: RootState) =>
  state.psmsViewTaxIdReducer?.extendedTinList;
export const getPsmsExtendedTinListLoading = (state: RootState) =>
  state.psmsViewTaxIdReducer?.extendedTinListLoading;
export const getPsmsExtendedTinListError = (state: RootState) =>
  state.psmsViewTaxIdReducer?.extendedTinListError;
/* --------------------------- */

/* Payment Integrity  */

export const getPsmsPaymentIntegritySummaryData = (state: RootState) => {
  return state.PsmsPaymentIntegrityReducer?.DenialRate;
};

export const getPsmsPaymentIntegritySummaryLoading = (state: RootState) => {
  return state.PsmsPaymentIntegrityReducer?.isLoading;
};

export const getPsmsPaymentIntegritySummaryError = (state: RootState) => {
  return state.PsmsPaymentIntegrityReducer?.error;
};

export const getPSMSEvaluationDetailsDataLoading = (state: RootState) => {
  return state.PsmsPaymentIntegrityReducer?.isEvaluationDetailsLoading;
};
export const getPSMSEvaluationDetailsData1 = (state: RootState) => {
  return state.PsmsPaymentIntegrityReducer?.evaluationDetailsData;
};

export const getAuditReasonCodeTableDataLoading = (state: RootState) => {
  return state.PsmsPaymentIntegrityReducer.isAuditCodeReasonsLoading;
};

export const getAuditReasonCodeTableData = (state: RootState) => {
  return state.PsmsPaymentIntegrityReducer?.auditCodeReasons;
};

export const getPsmsDigitalAdoptionSummaryData = (state: RootState) => {
  return state.PsmsDigitalAdoptionReducer.ediData;
};

export const getPsmsDigitalAdoptionSummaryLoading = (state: RootState) => {
  return state.PsmsDigitalAdoptionReducer?.isLoading;
};
export const getPsmsDigitalAdoptionSummaryError = (state: RootState) => {
  return state.PsmsDigitalAdoptionReducer?.error;
};

export const getPSMSDigitalSolutionAdoptionRate = (state: RootState) => {
  return state.PsmsDigitalAdoptionReducer.adoptionRate;
};

export const getPSMSDigitalSolutionAdoptionRateLoading = (state: RootState) => {
  return state.PsmsDigitalAdoptionReducer?.isLoadigAdoptionRate;
};
export const getPSMSDigitalSolutionAdoptionRateError = (state: RootState) => {
  return state.PsmsDigitalAdoptionReducer?.error;
};

export const getPsmsIndicatorData = (state: RootState) =>
  state.psmsReducer?.psmsIndicatorData || [];
